<div class="wrapper"
	[ngClass]="{
		'subtrack-theme': theme === 'subtrack-theme',
		'chapter-theme': theme === 'chapter-theme'
	}">
	<div class="info">
		<ng-container *ngIf="dragger === 'chapter'">
			<div [style.margin-left]="'5px'">
				<i class="fa fa-paragraph"></i>
			</div>
			<span class="chapter-label" *ngIf="dragger === 'chapter'">
				{{ timepointConfig?.label }}
			</span>
		</ng-container>
		<ng-container *ngIf="dragger === 'keyframe'">
			<div class="icon-wrapper">
				<i [class]="'fa fa-' + timepointConfig?.icon"></i>
			</div>
			<div *ngFor="let config of timepointConfig?.pillboxConfig; let i = index" class="pillbox-wrapper">
				<bb-pillbox [config]="config" [ind]="'ie-animate-track#'+ trackIndex + i" (onChangeProperty)="changeTimepointProperty($event)"></bb-pillbox>
			</div>
			<!-- placeholder button for now -->
			<div class="button-wrapper" (click)="onAddKeyframeButtonClicked()">
				<div class="keyframe-button" [class.active]="haveActiveKeyframe"></div>
			</div>
		</ng-container>
	</div>
	<div class="bb-track-zoom" #bbTrackZoom>
		<div class="timepoint-container" #timepointContainer [class.dragging]="dragging.anyDrag">
			<div *ngIf="timepointConfig?.timepoints?.data?.length > 0">
				<ng-container *ngFor="let item of timepointConfig?.timepoints.data; let i = index; trackBy: trackBy">
					<timepoint 
					#timepointRef
					[selected]="keyframeSelection?.selected?.indexOf(item.id) > -1"
					[maxTime]="duration"
					[dragger]="dragger"
					[tooltip]="dragging[i] ? 'hide' : tooltip"
					[dragging]="dragging[i]"
					[timepoint]="item?.time"
					[label]="item?.label"
					[offsetDifference]="item?.offsetDifference"
					[class.dragging]="dragging[i]"
					[style.z-index]="dragging[i]? '1' : 'inherit'"
					[class.is-left]="showLeftObj[i] || tooltip === 'left'"
					[ngStyle]="item.timepointOffset"
					(onEdit)="editMode = $event"
					bbDrag
					[bbDragDisabled]="editMode"
					[bbDragAxis]="'x'"
					[bbDragContainer]="bbTrackZoom"
					(bbDragStarted)="onDragStart($event, i)"
					(bbDragEnded)="onDragEnd(item.time, $event, i)"
					(onLabelChange)="changeChapterLabel(item.widgetId, $event)"
					(mousedown)="onTimepointMousedown(item, $event)"
					(onTimepointChange)="changeTimepointPosition($event, i)">
					</timepoint>
				</ng-container>
			</div>
		</div>
	</div>
</div>
